import { HyperlinkOpenMode } from '@shared/types/process';
import { openExternalUrl } from '@shared/util/openExternalUrl';

export type HyperlinkOptions = {
    url: string;
    openMode: HyperlinkOpenMode;
};

type ButtonActionLike = {
    actionCode: string;
    options?: unknown;
};

export const getHyperlinkOptions = (
    buttonActions?: ButtonActionLike[],
): HyperlinkOptions | null => {
    const value = buttonActions?.find(
        (action) => action.actionCode === 'Hyperlink',
    )?.options;

    try {
        const options =
            typeof value === 'string' ? (JSON.parse(value) as unknown) : value;

        if (!options || typeof options !== 'object') return null;

        const { url, openMode } = options as Partial<HyperlinkOptions>;
        if (
            typeof url !== 'string' ||
            (openMode !== 'CurrentTab' && openMode !== 'NewTab')
        ) {
            return null;
        }

        return { url, openMode };
    } catch {
        return null;
    }
};

export const openHyperlink = ({ url, openMode }: HyperlinkOptions) => {
    let resolved: URL;
    try {
        resolved = new URL(url, window.location.origin);
    } catch {
        return false;
    }

    if (resolved.protocol !== 'http:' && resolved.protocol !== 'https:') {
        return false;
    }

    if (openMode === 'CurrentTab') {
        window.location.assign(resolved.href);
        return true;
    }

    return openExternalUrl(resolved.href);
};
